import {  useMutation } from '@tanstack/react-query';
import { checkAvailability } from '../api/spots';

interface CheckAvailabilityParams {
  startDate: any;
  endDate: any;
}

export const useCheckAvailability = () => {
  return useMutation({
    mutationFn: ({ startDate, endDate }: CheckAvailabilityParams ) => checkAvailability(startDate, endDate),
  });
};